











































import DictMixin from '@/mixins/dict-mixin';
import MenuMixin from '@/mixins/menu-mixin';
import moment from 'moment';
import DatajobServices, { TriggerJobDto } from '@/services/datajob';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import JobDetail from './datajob-record-detail.vue';
@Component({
  components: { JobDetail }
})
export default class JobList extends mixins(DictMixin, MenuMixin) {
  @Prop() name!: any;
  @Prop() type!: any;
  @Prop() list!: any;

  jobSrv = new DatajobServices();
  date: any = '';
  streamJobRunning: boolean = false;

  get TYPE() {
    return this.type.toUpperCase();
  }

  visible = false;
  visible2 = false;

  pagination = { showTotal: () => `共 ${this.list.length} 条` };
  columns = [
    { title: '作业编号', dataIndex: 'jobCode' },
    { title: this.name, dataIndex: 'jobName' },
    { title: '作业处理数据日期', dataIndex: 'dataDate' },
    {
      title: '调度时间',
      dataIndex: 'triggerTime',
      scopedSlots: {
        customRender: (text: string) => { return moment(text).format('YYYY-MM-DD HH:mm:ss') }
      }
    },
    {
      title: '调度结果',
      dataIndex: 'triggerCode',
      scopedSlots: {
        customRender: 'triggerCode'
      }
    },
    {
      title: '执行时间',
      dataIndex: 'handleTime',
      scopedSlots: {
        customRender: (text: string) => { return moment(text).format('YYYY-MM-DD HH:mm:ss') }
      }
    },
    {
      title: '执行结果',
      dataIndex: 'handleCode',
      scopedSlots: {
        customRender: 'handleCode'
      }
    },
    { title: '作业执行人', dataIndex: 'createUser' },
    {
      title: '操作',
      dataIndex: 'action',
      width: 140,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];

  detail: any = {};
  async getDetail(record: any) {
    this.detail = record;
    this.visible = true;
  }

  async jobStop(record: any) {
    this.$confirm({
      title: '停止确认',
      content: '是否确认操作！',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        let res = await this.jobSrv.stop(record.id);
        res = await this.jobSrv.kill(record);
        if (res) {
          this.$message.success('操作成功');
        }
      }
    });
  }

  async reRun(record: any) {
    this.submitBatch([
      {
        jobId: record.jobId,
        jobType: record.jobType,
        executorParam: '',
        triggerType: 2,
        handleDataDate: record.dataDate
      }
    ]);
  }

  selectedRows: any[] = [];
  selectedRowKeys: any[] = [];
  onSelectChange(keys: any, rows: any) {
    this.selectedRowKeys = keys;
    this.selectedRows = rows;
  }
  async handleBatch(e: any) {
    if (e.key === 'reRunAll') {
      if (this.selectedRows.length === 0) {
        this.$message.error('请选中至少一条数据');
        return false;
      }
      let params: TriggerJobDto[] = this.selectedRows.map((record: any) => ({
        jobId: record.jobId,
        jobType: record.jobType,
        executorParam: '',
        triggerType: 2,
        handleDataDate: record.dataDate
      }));
      this.submitBatch(params);
    }
  }

  async submitBatch(params: TriggerJobDto[]) {
    this.$confirm({
      title: '重跑确认',
      content: '是否确认操作！',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        let res = await this.jobSrv.triggerBatch(params);
        if (res) {
          this.$message.success('操作成功');
          this.selectedRowKeys = [];
          this.$emit('reload');
        }
      }
    });
  }

  @Watch('$route')
  onRouteChange() {
    /\/jobs\/record/.test(this.$route.path) && this.$emit('reload');
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
